export default __webpack_public_path__ + "static/media/Hype-Empire.c4a9d5b4.png";